/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : Account.jsx
 * description   : {{insert here}}
 * creation date : 17/01/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    Text,
    Flex,
    Heading,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
    toolKit,
} from '@/components/core';

import {
    ContentContainer,
} from '@/components/snippets/ContentDiv';

import {
    ViewPortContainer,
    ButtonNavigateToSignIn,
    ButtonSignOut,
} from '@/components/snippets/CustomDiv';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function Account() {
    // Component context
    const { ctx } = useComponentContext();

    return (
        <Fragment>
            <ContentContainer
                title='Account' // TODO: Translate message
            >
                <ViewPortContainer>
                    {/* Is authenticated */}
                    {(ctx.auth.state === toolKit.enums.auth.stateTypes.AUTHENTICATED) &&
                        <Fragment>
                            <Flex
                                alignItems='center'
                                direction='column'
                                gap={ctx.theme.tokens.space.zero}
                                paddingLeft={
                                    ctx.api.utils.adaptiveOption(
                                        ctx.theme.tokens.space.large,
                                        ctx.theme.tokens.space.large,
                                        ctx.theme.tokens.space.medium
                                    )
                                }
                                paddingRight={
                                    ctx.api.utils.adaptiveOption(
                                        ctx.theme.tokens.space.large,
                                        ctx.theme.tokens.space.large,
                                        ctx.theme.tokens.space.medium
                                    )
                                }
                                paddingTop={
                                    ctx.api.utils.adaptiveOption(
                                        ctx.theme.tokens.space.large,
                                        ctx.theme.tokens.space.medium,
                                        ctx.theme.tokens.space.small
                                    )
                                }
                                paddingBottom={
                                    ctx.api.utils.adaptiveOption(
                                        ctx.theme.tokens.space.large,
                                        ctx.theme.tokens.space.medium,
                                        ctx.theme.tokens.space.small
                                    )
                                }
                                textAlign='center'
                            >
                                <Heading
                                    level={4}
                                    paddingBottom={ctx.theme.tokens.space.large}
                                >
                                    {/* TODO: Translate message */}
                                    Welcome <i><b>{ctx.auth.user.attributes.name}</b></i>
                                </Heading>

                                <Table
                                    caption='User attributes' // TODO: Translate message
                                    highlightOnHover={true}
                                    variation='striped'
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                as='th'
                                            >
                                                Key
                                            </TableCell>

                                            <TableCell
                                                as='th'
                                            >
                                                Value
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {Object.keys(ctx.auth.user.attributes).map((key, index) => {
                                            return (
                                                <Fragment
                                                    key={index}
                                                >
                                                    <TableRow>
                                                        <TableCell>
                                                            {key}
                                                        </TableCell>

                                                        <TableCell>
                                                            {ctx.auth.user.attributes[key]}
                                                        </TableCell>
                                                    </TableRow>
                                                </Fragment>
                                            );
                                        })}
                                    </TableBody>
                                </Table>

                                <ButtonSignOut
                                    fontWeight='normal'
                                    size='small'
                                    variation='link'
                                    marginTop={ctx.theme.tokens.space.xl}
                                />
                            </Flex>
                        </Fragment>
                    }

                    {/* Is NOT authenticated */}
                    {(ctx.auth.state === toolKit.enums.auth.stateTypes.UNAUTHENTICATED) &&
                        <Fragment>
                            <Flex
                                alignItems='center'
                                direction='column'
                                gap={ctx.theme.tokens.space.zero}
                                paddingLeft={
                                    ctx.api.utils.adaptiveOption(
                                        ctx.theme.tokens.space.large,
                                        ctx.theme.tokens.space.large,
                                        ctx.theme.tokens.space.medium
                                    )
                                }
                                paddingRight={
                                    ctx.api.utils.adaptiveOption(
                                        ctx.theme.tokens.space.large,
                                        ctx.theme.tokens.space.large,
                                        ctx.theme.tokens.space.medium
                                    )
                                }
                                paddingTop={
                                    ctx.api.utils.adaptiveOption(
                                        ctx.theme.tokens.space.xxxl,
                                        ctx.theme.tokens.space.xxxl,
                                        ctx.theme.tokens.space.large
                                    )
                                }
                                paddingBottom={
                                    ctx.api.utils.adaptiveOption(
                                        ctx.theme.tokens.space.xxxl,
                                        ctx.theme.tokens.space.xxxl,
                                        ctx.theme.tokens.space.xxxl
                                    )
                                }
                                textAlign='center'
                            >
                                <Text
                                    fontSize={
                                        ctx.api.utils.adaptiveOption(
                                            ctx.theme.tokens.fontSizes.xxxl,
                                            ctx.theme.tokens.fontSizes.xxl,
                                            ctx.theme.tokens.fontSizes.large
                                        )
                                    }
                                    fontWeight={ctx.theme.tokens.fontWeights.medium}
                                    lineHeight={ctx.theme.tokens.lineHeights.small}
                                >
                                    {/* TODO: Translate message */}
                                    YOU ARE NOT AUTHENTICATED
                                </Text>

                                <ButtonNavigateToSignIn
                                    fontWeight='normal'
                                    size='small'
                                    variation='link'
                                    marginTop={ctx.theme.tokens.space.large}
                                    className='custom-button-link'
                                />
                            </Flex>
                        </Fragment>
                    }
                </ViewPortContainer>
            </ContentContainer>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default Account;



// End of file
